import React from 'react'
import styled from 'styled-components'

// @ts-ignore
import sirotan from '/img/sirotan.jpg'
// @ts-ignore
import slimeandsirotan from '/img/slimeandsirotan.jpg'
// @ts-ignore
import ramen from '/img/ramen.jpg'
// @ts-ignore
import kimibeer from '/img/kimibeer.jpg'
// @ts-ignore
import relaxipa from '/img/relaxipa.jpg'
// @ts-ignore
import takoyaki from '/img/takoyaki.jpg'
// @ts-ignore
import bouquet from '/img/bouquet.jpg'

const images = [sirotan, slimeandsirotan, ramen, kimibeer, relaxipa, takoyaki, bouquet]


const getRandomInt = (min: number, max: number): number => {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min
}

const getImage = (list:string[]): string => {
    const random = getRandomInt(0, list.length)
    return list[random]
}


const Modal = (props: any) => {
    const { onDecline } = props
    const image = getImage(images)
    return (
        <Container>
            <Inner>
                <Heading>
                    <Title>AirDrop</Title>
                    <Description>chan-nanaさんが1枚の写真を共有しようとしています。</Description>
                </Heading>
                <Img src={image} />
                <ButtonContainer>
                    <Button onClick={onDecline}>辞退</Button>
                    <Button onClick={() => {
                        window.location.href = image
                    }}>受け入れる</Button>
                </ButtonContainer>
            </Inner>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
`
const Inner = styled.div`
    width: 300px;
    background-color: rgba(255,255,255,0.9);
    border-radius: 16px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
`
const Heading = styled.div`
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    height: 100px;
    box-sizing: border-box;
    padding: 0 12px;
`
const Title = styled.div`
    display: flex;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 4px;
`
const Description = styled.div`
    display: flex;
    font-size: 12px;
`
const Img = styled.div<any>`
    background-image: url("${(props) => props.src}");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    height: 200px;
`
const ButtonContainer = styled.div`
    display: flex;
`
const Button = styled.div`
    display: flex;
    width: 50%;
    justify-content: center;
    align-items: center;
    height: 50px;
    color: #1277FE;
    cursor: pointer;

    &:nth-child(2) {
        border-left: 1px solid #dcdcdc;
        font-weight: bold;
    }
`

export default Modal